import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { BancoRequest, Response } from './Types';

class BancoController {
  public static async Listar(request: BancoRequest): Promise<Response> {
    try {
      const response = await Api.post('api/banco/Listar', request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnico(bancoId: number): Promise<Response> {
    try {
      console.log('Controller Banco Listar Unico');
      console.log(bancoId);

      const response = await Api.get(`api/banco/ListarUnico/${bancoId}`);

      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object[0],
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Adicionar(request: BancoRequest): Promise<Response> {
    try {
      console.log('Controller Banco Adicionar');
      console.log(request);

      const response = await Api.post(`api/banco/Adicionar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Atualizar(request: BancoRequest): Promise<Response> {
    try {
      console.log('Controller Banco Atualizar');
      console.log(request);

      const response = await Api.put(`api/banco/Atualizar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Excluir(request: BancoRequest): Promise<Response> {
    try {
      console.log('Controller Banco Excluir');
      console.log(request);

      const response = await Api.put(`api/banco/Excluir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default BancoController;
